import * as React from 'react';
import { useSelector } from 'react-redux';
import { Actual, TooltipContent } from '../../components/PriceRelevance';
import { getPriceRelevance } from '../../selectors/newbuilding/priceRelevance';
import { EType } from '../../types/newbuilding/priceRelevance';
import { trackHover } from './tracking';

export const PriceRelevance = () => {
  const tooltip = useSelector(getPriceRelevance);

  if (!tooltip) {
    return null;
  }

  if (tooltip.type === EType.Warning) {
    return null;
  }

  return (
    <Actual
      label={tooltip.label}
      title={tooltip.title}
      description={<TooltipContent description={tooltip.description} onVisible={trackHover} />}
    />
  );
};

PriceRelevance.displayName = 'PriceRelevance';
